// From https://github.com/ittus/vue-long-click
export default (function (_ref) {
  var _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 400 : _ref$delay,
      _ref$interval = _ref.interval,
      interval = _ref$interval === void 0 ? 50 : _ref$interval;
  return {
    bind: function bind(el, binding, vNode) {
      if (typeof binding.value !== "function") {
        var compName = vNode.context.name;
        var warn = "[longclick:] provided expression '".concat(binding.expression, "' is not a function, but has to be");

        if (compName) {
          warn += "Found in component '".concat(compName, "' ");
        }

        console.warn(warn); // eslint-disable-line

        return;
      }

      var pressTimer = null;
      var pressInterval = null;

      var start = function start(e) {
        if (e.type === "mousedown" && e.button !== 0) {
          return;
        }

        if (pressTimer === null) {
          pressTimer = setTimeout(function () {
            if (interval && interval > 0) {
              pressInterval = setInterval(function () {
                handler();
              }, interval);
            }

            handler();
            pressTimer = null;
          }, delay);
        }
      }; // Cancel Timeout


      var cancel = function cancel() {
        if (pressTimer !== null) {
          clearTimeout(pressTimer);
          pressTimer = null;
        }

        if (pressInterval) {
          clearInterval(pressInterval);
          pressInterval = null;
        }
      }; // Run Function


      var handler = function handler(e) {
        binding.value(e);
      };

      ["mousedown", "touchstart"].forEach(function (e) {
        return el.addEventListener(e, start);
      });
      ["click", "mouseup", "touchend", "touchcancel"].forEach(function (e) {
        el.addEventListener(e, cancel);
      });
    }
  };
});